import React from 'react';
import { Redirect } from 'react-router-dom';
import pages from '../../pages';
import * as permissions from '../permissions';

export default [
  { path: '/stores', component: () => <Redirect to="/stores/list" /> },
  {
    path: '/stores/list',
    component: pages.stores.AllStoresPage,
    permission: permissions.PERM_STORES_PAGE_VIEW,
    redirectTo: 'growz',
  },
  { path: '/stores/report/status', component: pages.stores.UserStoresPage, permission: permissions.PERM_STORES_PAGE_VIEW },
  {
    path: '/stores/report/elevate',
    component: pages.stores.ElevateReportPage,
    permission: permissions.PERM_STORES_PAGE_VIEW,
  },
  { path: '/stores/users', component: pages.stores.UsersPage, permission: permissions.PERM_USERS_PAGE_VIEW },
  { path: '/stores/users/add/', component: pages.stores.AddUserPage, permission: permissions.PERM_USERS_ADD_NEW },
  { path: '/stores/users/:userId/edit/', component: pages.stores.AddUserPage, permission: permissions.PERM_USERS_UPDATE },
  { path: '/stores/roles', component: pages.stores.RolesPage, permission: permissions.PERM_ROLES_MANAGE },
  { path: '/stores/roles/create/', component: pages.stores.AddRolePage, permission: permissions.PERM_ROLES_MANAGE },
  { path: '/stores/roles/:role/edit/', component: pages.stores.AddRolePage, permission: permissions.PERM_ROLES_MANAGE },
  { path: '/stores/customize-theme', component: pages.stores.BrandingPage },
];
